import { Divider, Stack } from "@mui/material";
import { useParams } from "react-router";

import { GqlPermissions } from "~/__generated__";
import useHasTenantPermission from "~/modules/auth/hooks/useHasPermission";
import useMapEditorLayerGetById from "~/modules/mapEditor/api/useMapEditorLayerGetById";
import MapEditorLayerAddressImport from "~/modules/mapEditor/components/MapEditorLayerDetails/MapEditorLayerAddressImport";
import MapEditorLayerDisplay from "~/modules/mapEditor/components/MapEditorLayerDetails/MapEditorLayerDisplay";
import MapEditorLayerForm from "~/modules/mapEditor/components/MapEditorLayerDetails/MapEditorLayerForm";

import useRequireCurrentProject from "../../../hooks/useRequireCurrentProject";

export function ProjectMapEditorLayerSettingsScreen() {
    const { project } = useRequireCurrentProject();
    const { layerId } = useParams();
    if (!layerId) throw new Error("No layerId provided");
    const { data } = useMapEditorLayerGetById(layerId);
    const isAdmin = useHasTenantPermission(GqlPermissions.Administrator);

    return (
        <>
            {data && (
                <Stack padding={2} rowGap={2}>
                    {isAdmin ? (
                        <MapEditorLayerForm project={project} layerId={layerId} data={data} />
                    ) : (
                        <MapEditorLayerDisplay data={data} />
                    )}
                </Stack>
            )}

            {isAdmin && data !== undefined && (
                <>
                    <Divider />
                    <MapEditorLayerAddressImport layer={data} project={project} />
                </>
            )}
        </>
    );
}
